import(/* webpackMode: "eager", webpackExports: ["PaymentNotification"] */ "/vercel/path0/frontend/app/(routes)/go/send/components/PaymentNotification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/frontend/app/shared/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/frontend/app/shared/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/frontend/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/PostHogPageView.tsx");
